/* The home screen's hero card (UI redesign, Batch 1). One dark surface, calm: a quiet linear wash,
   no glow, no motion. Every colour is a `--hero-*` token and every text pair on it is measured in
   `backend/tests/unit/test_design_tokens_contrast.py`.

   **No figure is ever coloured**: the total and the scopes are `--hero-ink`, near-white. The brand
   green is chrome and an emissions total is not good news (tokens.css header, ADR-0090).

   The root is a `div` and not a `section`: `Readiness.module.css` restyles `.main > section` for the
   panels (block, visible overflow), and that rule would beat this grid on specificity. */

.hero {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);
  gap: 20px;
  padding: 20px;
  background: var(--hero-gradient);
  border: 1px solid var(--hero-line);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-hero);
  color: var(--hero-ink);
}

.left,
.right {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.eyebrow {
  color: var(--hero-muted);
  font-size: var(--t-min);
  font-weight: 600;
  letter-spacing: 0.08em;
  line-height: 1.3;
  text-transform: uppercase;
}

/* The total sits directly on the hero: its tile surface is removed, the tile's own type stays. */
.hero .total > * {
  padding: 0;
  background: none;
  border: 0;
  border-radius: 0;
}

.scopes {
  min-width: 0;
}

.facts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

/* The delta. Ink for every direction: the arrow says which way and the figure says how far. */
.delta {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 6px;
  color: var(--hero-ink-2);
  font-size: var(--t-dense);
  line-height: 1.3;
}

.deltaText b {
  font-weight: 600;
  color: var(--hero-ink);
}

.versus {
  color: var(--hero-muted);
}

@media (max-width: 1100px) {
  .hero {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 520px) {
  .hero {
    padding: 14px;
  }

  .facts {
    grid-template-columns: minmax(0, 1fr);
  }
}
